
export const NAVIGATE_AUTH = {
    AUTH: "/auth",
    LOGIN: "/login",
    LOGOUT: "/logout",
    REGISTER: "/register",
    get LOGIN_PAGE() { return `${this.AUTH}${this.LOGIN}`; },    //navigate to -->  /auth/login
    get LOGOUT_PAGE() { return `${this.AUTH}${this.LOGOUT}`; },
}

export const NAVIGATE_RECRUITMENT = {
    RECRUITMENT: "/recruitment",


    DEPARTMENT: {
        DEPARTMENTS: "/departments",
        DETAILS: "/details",
        get DEPARTMENT_LIST_PAGE() { return `${NAVIGATE_RECRUITMENT.RECRUITMENT}${this.DEPARTMENTS}`; },
    },
    DESIGNATION: {
        DESIGNATIONS: "/designations",
        DETAILS: "/details",
        get DESIGNATION_LIST_PAGE() { return `${NAVIGATE_RECRUITMENT.RECRUITMENT}${this.DESIGNATIONS}`; },
    },
   
    JOB: {
        JOBS: "/jobs",
        DETAILS: "/details",
        get JOB_LIST_PAGE() { return `${NAVIGATE_RECRUITMENT.RECRUITMENT}${this.JOBS}`; },
        get JOB_DETAILS_PAGE() { return `${NAVIGATE_RECRUITMENT.RECRUITMENT}${this.JOBS}${this.DETAILS}`; },
    },

    CANDIDATE: {
        CANDIDATES: "/candidates",
        DETAILS: "/details",
        RESUME: "/resume",  
           //CHECK REFERENCES
        get CANDIDATE_LIST_PAGE() { return `${NAVIGATE_RECRUITMENT.RECRUITMENT}${this.CANDIDATES}`; },                   //navigate to -->  /recruitment/candidates
        get CANDIDATE_DETAILS_PAGE() { return `${NAVIGATE_RECRUITMENT.RECRUITMENT}${this.CANDIDATES}${this.DETAILS}`; }, //navigate to -->  /recruitment/candidates/details
    },

    INTERVIEW: {
        INTERVIEWS: "/interviews",
        get INTERVIEW_LIST_PAGE() { return `${NAVIGATE_RECRUITMENT.RECRUITMENT}${this.INTERVIEWS}`; },
    },

    ONBOARD: {
        ONBOARDS: "/onboards",
        DETAILS: "/details",
        get ONBOARD_LIST_PAGE() { return `${NAVIGATE_RECRUITMENT.RECRUITMENT}${this.ONBOARDS}`; },
        get ONBOARD_DETAILS_PAGE() { return `${NAVIGATE_RECRUITMENT.RECRUITMENT}${this.ONBOARDS}${this.DETAILS}`; },
    },

    REFERRAL: {
        REFERRALS: "/referrals",
        DETAILS: "/details",
        get REFERRAL_LIST_PAGE() { return `${NAVIGATE_RECRUITMENT.RECRUITMENT}${this.REFERRALS}`; },
        get REFERRAL_DETAILS_PAGE() { return `${NAVIGATE_RECRUITMENT.RECRUITMENT}${this.REFERRALS}${this.DETAILS}`; },
    },

    CANDIDATE_ASSESSMENTS: {
        CANDIDATE_ASSESSMENT: "/candidate-assessment",
        get CANDIDATE_ASSESSMENT_PAGE() { return `${NAVIGATE_RECRUITMENT.RECRUITMENT}${this.CANDIDATE_ASSESSMENT}`; },
    },

    VENDOR: {
        VENDORS: "/vendors",
        DETAILS: "/details",
        get VENDOR_LIST_PAGE() { return `${NAVIGATE_RECRUITMENT.RECRUITMENT}${this.VENDORS}`; },
        get VENDOR_DETAILS_PAGE() { return `${NAVIGATE_RECRUITMENT.RECRUITMENT}${this.VENDORS}${this.DETAILS}`; },
    },
    BACKOUT: {
        BACKOUTS: "/backout-candidates",
        DETAILS: "/details",
        // get VENDOR_LIST_PAGE() { return `${NAVIGATE_RECRUITMENT.RECRUITMENT}${this.VENDORS}`; },
        // get VENDOR_DETAILS_PAGE() { return `${NAVIGATE_RECRUITMENT.RECRUITMENT}${this.VENDORS}${this.DETAILS}`; },
    },

    OPENPAGE: {
        get JOB_OPENING_PAGE() { return `/guest/action/recruitment/job/opening`; },
        get JOB_APPROVE_PAGE() { return `/guest/action/recruitment/job/approve`; },    //CHECK REFERENCES
        get JOB_THANKYOUFOR_APPLYINGJOB_PAGE() { return `/guest/action/recruitment/job/thank-you-for-applying-job`; },
        get APPROVAL_OFFER_ACCEPT_REJECT_REQUEST_PAGE() { return `/guest/action/recruitment/approval/offer-approve-reject-request`; },
        get INTERVIEW_ONBOARD_REQUEST_PAGE() { return `/guest/action/recruitment/interview/onboard-request`; },
        get INTERVIEW_UPLOADDOCUMENT_REQUEST_PAGE() { return `/guest/action/recruitment/offer-request/upload-document`; },
        get CANDIDATE_OFFER_ACCEPT_REJECT_REQUEST_PAGE() { return `/guest/action/recruitment/candidate/offer-accept-reject-request`; },
    },

    MASTERS: {
        MASTERS: "/masters",
        LOCATION: "/locations",
        CTC_CONFIG: "/ctc-config",
        MASTER_LANDING: "/landing",
        // get MASTER_LANDING_PAGE() { return `${NAVIGATE_RECRUITMENT.RECRUITMENT}${this.MASTERS}`; },
        // DOCUMENTMASTER: "/document-master",
        // DOCUMENTMASTER_MANAGE: "/document-master-manage",
        // get DOCUMENTMASTER_PAGE() { return `${NAVIGATE_RECRUITMENT.RECRUITMENT}${this.MASTERS}${this.DOCUMENTMASTER}`; },
        // get DOCUMENTMASTER_MANAGE_PAGE() { return `${NAVIGATE_RECRUITMENT.RECRUITMENT}${this.MASTERS}${this.DOCUMENTMASTER_MANAGE}`; },

       WORKFLOWMASTER: "/workflow-master",
       get WORKFLOWMASTER_PAGE() { return `${NAVIGATE_RECRUITMENT.RECRUITMENT}${this.MASTERS}${this.WORKFLOWMASTER}`; },


    },

    DASHBOARD: {
        DASHBOARD: "/dashboard",
        get DASHBOARD_LIST_PAGE() { return `${NAVIGATE_RECRUITMENT.RECRUITMENT}${this.DASHBOARD}`; },
    },

    REPORT: {
        REPORT: "/report",
        get REPORT_LIST_PAGE() { return `${NAVIGATE_RECRUITMENT.RECRUITMENT}${this.REPORT}`; },
    },

}

export const NAVIGATE_SETTING = {
    SETTINGS: "/settings",
    PROFILE: "/profile",
    USERPROFILE: "/userprofile",
    INTEGRATIONS: "/integrations",
    EMPLOYEE_LIST: "/employee-list",
    PREFERENCES: "/preferences",
    get SETTINGS_PAGE() { return `${this.SETTINGS}`; },
    get PREFERENCES_SETTING_PAGE() { return `${this.SETTINGS}${this.PREFERENCES}`; },
    get EMPLOYEE_LIST_PAGE() { return `${this.SETTINGS}${this.EMPLOYEE_LIST}`; },
    get INTEGRATIONS_SETTING_PAGE() { return `${this.SETTINGS}${this.INTEGRATIONS}`; },
    get PROFILE_SETTING_PAGE() { return `${this.SETTINGS}${this.PROFILE}`; },
    get USERPROFILE_SETTING_PAGE() { return `${this.SETTINGS}${this.USERPROFILE}`; },
    get NOTIFICATIONS_SETTING_PAGE() { return `${this.SETTINGS}/notifications`; },
    get EMAIL_SETTING_PAGE() { return `${this.SETTINGS}/email-settings`; },
    get PREFERENCES_DATEFORMAT_PAGE() { return `${this.SETTINGS}${this.PREFERENCES}/date-format`; },
    get PREFERENCES_TIMEFORMAT_PAGE() { return `${this.SETTINGS}${this.PREFERENCES}/time-format`; },
    get PREFERENCES_CURRENCY_PAGE() { return `${this.SETTINGS}${this.PREFERENCES}/currency`; },
    get PREFERENCES_LANGUAGE_PAGE() { return `${this.SETTINGS}${this.PREFERENCES}/language`; },
    get PROFILE_FULLNAME_PAGE() { return `${this.SETTINGS}${this.PROFILE}/full-name`; },
    get PROFILE_DISPLAYNAME_PAGE() { return `${this.SETTINGS}${this.PROFILE}/display-name`; },
    get PROFILE_ROLE_PAGE() { return `${this.SETTINGS}${this.PROFILE}/role`; },
    get PROFILE_EMAIL_PAGE() { return `${this.SETTINGS}${this.PROFILE}/email`; },
    get PROFILE_PHONENUMBER_PAGE() { return `${this.SETTINGS}${this.PROFILE}/Phone-number`; },
    get PROFILE_LOCATION_PAGE() { return `${this.SETTINGS}${this.PROFILE}/location`; },
    get PROFILE_CHANGEPASSWORD_PAGE() { return `${this.SETTINGS}${this.PROFILE}/change-password`; },
}

export const NAVIGATE_ATTENDANCE = {
    ATTENDANCE: "/attendance",


    WORKFLOW: "/workflow",
    get WORKFLOW_PAGE() { return `${this.ATTENDANCE}${this.WORKFLOW}`; },  // "/attendance/workflow"


    MASTERS: {
        MASTERS: "/masters",
        // LOCATION: "/locations",
        CTC_CONFIG: "/attendance-config",
        get MASTER_LANDING_PAGE() { return `${NAVIGATE_ATTENDANCE.ATTENDANCE}${this.MASTERS}`; },
        // POLICY: "/policy",
        // HOLIDAY: "/holiday",
        // HOLIDAYEMANAGE: "/holiday/holiday-manage",
        // SHIFT: "/shift",
        // SHIFTMANAGE: "/shift/shift-manage",
        // ATTENDANCE_CYCLE: "/attendance-cycle",
        // get POLICY_PAGE() { return `${NAVIGATE_ATTENDANCE.ATTENDANCE}${this.MASTERS}${this.POLICY}`; }, //navigate to -->  /attendance/masters/policy
        // get HOLIDAY_PAGE() { return `${NAVIGATE_ATTENDANCE.ATTENDANCE}${this.MASTERS}${this.HOLIDAY}`; },
        // get HOLIDAY_MANAGE_PAGE() { return `${NAVIGATE_ATTENDANCE.ATTENDANCE}${this.MASTERS}${this.HOLIDAYEMANAGE}`; },
        // get SHIFT_PAGE() { return `${NAVIGATE_ATTENDANCE.ATTENDANCE}${this.MASTERS}${this.SHIFT}`; },
        // get SHIFT_MANAGE_PAGE() { return `${NAVIGATE_ATTENDANCE.ATTENDANCE}${this.MASTERS}${this.SHIFTMANAGE}`; },
        DETAILS: "/details",
        // get POLICY_DETAILS_PAGE() { return `${NAVIGATE_ATTENDANCE.ATTENDANCE}${this.MASTERS}${this.POLICY}${this.DETAILS}`; }, //navigate to -->  /attendance/masters/policy/details
        // WEEKOFF_MASTER: "/weekoff-master",
        // get WEEKOFF_MASTER_PAGE() { return `${NAVIGATE_ATTENDANCE.ATTENDANCE}${this.MASTERS}${this.WEEKOFF_MASTER}`; }, //navigate to -->  /attendance/masters/policy

    //    get ATTENDANCE_CYCLE_LIST_PAGE() { return `${NAVIGATE_ATTENDANCE.ATTENDANCE}${this.MASTERS}${this.ATTENDANCE_CYCLE}`; },
    //    get LOCATION_LIST_PAGE() { return `${NAVIGATE_ATTENDANCE.ATTENDANCE}${this.MASTERS}${this.LOCATION}`; },


       LEAVE_POLICY: "/leave-policy",  //move in NAVIGATE_LEAVE 
       get LEAVE_POLICY_LIST_PAGE() { return `${NAVIGATE_ATTENDANCE.ATTENDANCE}${this.MASTERS}${this.LEAVE_POLICY}`; },    //move in NAVIGATE_LEAVE 

        MASTER_LANDING:"/landing",


     }
}



export const NAVIGATE_LEAVE = {
    LEAVE_TRACKER:"/leave-tracker",
}


export const NAVIGATE_COMPENSATION = {
    COMPENSATION: "/compensation",
    SUMMARY: "/summary",
    MYPAY: "/mypay",
    MANAGETAX: "/managetax",
    FORMS: "/forms",

    get NAVIGATE_COMPENSATION_SUMMARY_PAGE() { return `${NAVIGATE_COMPENSATION.COMPENSATION}${NAVIGATE_COMPENSATION.SUMMARY}`},
    get NAVIGATE_COMPENSATION_MYPAY_PAGE() { return `${NAVIGATE_COMPENSATION.COMPENSATION}${NAVIGATE_COMPENSATION.MYPAY}`},
    get NAVIGATE_COMPENSATION_MANAGETAX_PAGE() { return `${NAVIGATE_COMPENSATION.COMPENSATION}${NAVIGATE_COMPENSATION.MANAGETAX}`},
    get NAVIGATE_COMPENSATION_FORMS_PAGE() { return `${NAVIGATE_COMPENSATION.COMPENSATION}${NAVIGATE_COMPENSATION.FORMS}`},
    get NAVIGATE_COMPENSATION_MATERS_PAGE() { return `${NAVIGATE_COMPENSATION.COMPENSATION}${NAVIGATE_COMPENSATION.MASTERS}`},

    MASTERS:{
        MASTERS:"/masters",
        DEDUCTION :"/statutory",
        // SALARY:"/salary",
        // SALARY_TEMPLATES:"/salary-template",
        ADD_SALARY_TEMPLATES:"/salary-template-create",
        get CREATE_SALARY_TEMPLATES_PAGE() { return `${NAVIGATE_COMPENSATION.COMPENSATION}${this.MASTERS}${this.DEDUCTION}` },
        get COMPENSATION_DEDUCTION_MASTER_PAGE() { return `${NAVIGATE_COMPENSATION.COMPENSATION}${this.MASTERS}${this.DEDUCTION}` },
        // get COMPENSATION_SALARY_MASTER_PAGE() { return `${NAVIGATE_COMPENSATION.COMPENSATION}${this.MASTERS}${this.SALARY}`},
        // get COMPENSATION_SALARY_TEMPLATES_MASTER_PAGE() { return `${NAVIGATE_COMPENSATION.COMPENSATION}${this.MASTERS}${this.SALARY_TEMPLATES}` },
        get COMPENSATION_SALARY_TEMPLATES_MASTER_CREATE_PAGE() { return `${NAVIGATE_COMPENSATION.COMPENSATION}${this.MASTERS}${this.ADD_SALARY_TEMPLATES}` },



    SALARY_COMPONENT :{
        SALARY_COMPONENT : '/salary-components',
        EARNING : '/earning',
        CORRECTION : '/corrections',
        POST_TAX_DEDUCTION : '/post-tax-deducton',
        PRE_TAX_DEDUCTION : '/pre-tax-deducton',
        REIMBURSMENT : '/reimbursment',
       
        get COMPENSATION_SALARY_COMPONENT_EARNING_PAGE() { return `${NAVIGATE_COMPENSATION.COMPENSATION}${NAVIGATE_COMPENSATION.MASTERS.MASTERS}${this.SALARY_COMPONENT}${this.EARNING}` }, //comapa/master//salary-components/earning
        get COMPENSATION_SALARY_COMPONENT_CORRECTION_PAGE() { return `${NAVIGATE_COMPENSATION.COMPENSATION}${NAVIGATE_COMPENSATION.MASTERS.MASTERS}${this.SALARY_COMPONENT}${this.CORRECTION}` },
        get COMPENSATION_SALARY_COMPONENT_POST_TAX_DEDUCTION_PAGE() { return `${NAVIGATE_COMPENSATION.COMPENSATION}${NAVIGATE_COMPENSATION.MASTERS.MASTERS}${this.SALARY_COMPONENT}${this.POST_TAX_DEDUCTION}` },
        get COMPENSATION_SALARY_COMPONENT_PRE_TAX_DEDUCTION_PAGE() { return `${NAVIGATE_COMPENSATION.COMPENSATION}${NAVIGATE_COMPENSATION.MASTERS.MASTERS}${this.SALARY_COMPONENT}${this.PRE_TAX_DEDUCTION}` },
        get COMPENSATION_SALARY_COMPONENT_REIMBURSMENT_PAGE() { return `${NAVIGATE_COMPENSATION.COMPENSATION}${NAVIGATE_COMPENSATION.MASTERS.MASTERS}${this.SALARY_COMPONENT}${this.REIMBURSMENT}` },
    },



    },

    SALARY_COMPONENT :{
        SALARY_COMPONENT : '/salary-components',
        EARNING : '/earning',
        CORRECTION : '/corrections',
        POST_TAX_DEDUCTION : '/post-tax-deducton',
        PRE_TAX_DEDUCTION : '/pre-tax-deducton',
        REIMBURSMENT : '/reimbursment',
        SALARY: '/salary',

        get COMPENSATION_SALARY_COMPONENT_EARNING_PAGE() { return `${NAVIGATE_COMPENSATION.COMPENSATION}${this.SALARY_COMPONENT}${this.EARNING}` },
        get COMPENSATION_SALARY_COMPONENT_CORRECTION_PAGE() { return `${NAVIGATE_COMPENSATION.COMPENSATION}${this.SALARY_COMPONENT}${this.CORRECTION}` },
        get COMPENSATION_SALARY_COMPONENT_POST_TAX_DEDUCTION_PAGE() { return `${NAVIGATE_COMPENSATION.COMPENSATION}${this.SALARY_COMPONENT}${this.POST_TAX_DEDUCTION}` },
        get COMPENSATION_SALARY_COMPONENT_PRE_TAX_DEDUCTION_PAGE() { return `${NAVIGATE_COMPENSATION.COMPENSATION}${this.SALARY_COMPONENT}${this.PRE_TAX_DEDUCTION}` },
        get COMPENSATION_SALARY_COMPONENT_REIMBURSMENT_PAGE() { return `${NAVIGATE_COMPENSATION.COMPENSATION}${this.SALARY_COMPONENT}${this.REIMBURSMENT}` },
        get COMPENSATION_SALARY_COMPONENT_SALARY_PAGE() { return `${NAVIGATE_COMPENSATION.COMPENSATION}${this.SALARY_COMPONENT}${this.SALARY}` },
    },

}

export const NAVIGATE_NOTIFICATION = {
    NOTIFICATION: "/notifications",
    MASTERS: {
        MASTERS: "/masters",
        NOTIFICATION_MASTER :"/notification-master",
        get MASTER_LANDING_PAGE() { return `${NAVIGATE_NOTIFICATION.NOTIFICATION}${this.MASTERS}`; },
        get MASTER_NOTIFICATION_MASTER_PAGE() { return `${NAVIGATE_NOTIFICATION.NOTIFICATION}${this.MASTERS}${this.NOTIFICATION_MASTER}`; },
    }
}

export const ERROR = {
    ERROR_403: "/403",
    ERROR_404: "/access_denied",
    USERNOTFOUND:"/user_not_found",
    get ERROR_403_PAGE() { return `/recruitment/403`; },
}


export const NAVIGATE_DASHBOARD = {
    DASHBOARD: "/dashboard",
    get DASHBOARD_PAGE() { return `${this.DASHBOARD}`; },
}
export const NAVIGATE_EMPLOYEE = { 
    EMPLOYEE: "/employee",
    DETAILS: "/details",
    EMPLOYEE_LISTING: "/listing",
    EMPLOYEE_PAYROLL: "/payroll",
    EMPLOYEE_FEEDBACK: "/feedback",
    EMPLOYEE_CHANGES: "/employee-changes",
    PAYROLL_DETAILS: "/payroll-details",
    EMPLOYEE_LOAN: "/loan",
    ASSETS: "/assets",
    EMP_BACKDATED_ATTENDANCE_BY_ADMIN: "/backdated-attendance-admin",

    EMPLOYEE_PROFILE_UPDATE_REQUESTS : "/profile-update-requests",
    get EMPLOYEE_LISTING_PAGE() { return `${NAVIGATE_EMPLOYEE.EMPLOYEE}${this.EMPLOYEE_LISTING}`; },
    get EMPLOYEE_PAYROLL_PAGE() { return `${NAVIGATE_EMPLOYEE.EMPLOYEE}${this.EMPLOYEE_PAYROLL}`; },
    get EMPLOYEE_FEEDBACK_PAGE() { return `${NAVIGATE_EMPLOYEE.EMPLOYEE}${this.EMPLOYEE_FEEDBACK}`; },
    get EMPLOYEE_CHANGES_PAGE() { return `${NAVIGATE_EMPLOYEE.EMPLOYEE}${this.EMPLOYEE_CHANGES}`; },
    get EMPLOYEE_LOAN_PAGE() { return `${NAVIGATE_EMPLOYEE.EMPLOYEE}${this.EMPLOYEE_LOAN}`; },
    get EMPLOYEE_DETAILS_PAGE() { return `${NAVIGATE_EMPLOYEE.EMPLOYEE}${this.DETAILS}`; },
    get EMPLOYEE_PAYROLL_DETAILS_PAGE() { return `${NAVIGATE_EMPLOYEE.EMPLOYEE}${this.PAYROLL_DETAILS}`; },
    HIERARCHY: "/team-hierarchy",
    get HIERARCHY_PAGE() { return `${NAVIGATE_EMPLOYEE.EMPLOYEE}${this.HIERARCHY}`; },
    get ASSETS_PAGE() { return `${NAVIGATE_EMPLOYEE.EMPLOYEE}${this.ASSETS}`; },
    get EMP_BACKDATED_ATTENDANCE_BY_ADMIN_PAGE() { return `${NAVIGATE_EMPLOYEE.EMPLOYEE}${this.EMP_BACKDATED_ATTENDANCE_BY_ADMIN}`; },
}


export const NAVIGATE_MYTEAM = {
    MYTEAM: "/myteamzone",
    get MYTEAM_PAGE() { return `${this.MYTEAM}`; },

}

export const NAVIGATE_PEOPLE = {
    PEOPLE: "/employee-people",
    DETAILS: "/details",
    PEOPLE_LISTING: "/listing",
    get PEOPLE_LISTING_PAGE() { return `${NAVIGATE_PEOPLE.PEOPLE}${this.PEOPLE_LISTING}`; },
    get PEOPLE_DETAILS_PAGE() { return `${NAVIGATE_PEOPLE.PEOPLE}${this.DETAILS}`; },

}
export const NAVIGATE_POLICY = {
    POLICIES: "/company-policy", 
}


export const NAVIGATE_ALL_MASTER = {
    MASTER:"masters",
    DEPARTMENT: "/departments",
    CLIENT: "/clients",
    DESIGNATION: "/designations",
    BRANCH_LOCATION: "/branch-location",
    BRANCH_LOCATION_MAPPING: "/branch-vertical-mapping",
    ANNOUNCEMENT: "/announcement",


    WORKFLOWMASTER: "/workflow",
    get WORKFLOWMASTER_PAGE() { return `${this.WORKFLOWMASTER}`; },
    FUNCTIONAL_ROLE: "/functional-role",
    get FUNCTIONAL_ROLE_PAGE() { return `${this.WORKFLOWMASTER}${this.FUNCTIONAL_ROLE}`; },

    RECRUITMENT_LANDING_PAGE: "/recruitment",
    get RECRUITMENT_MASTER_LANDING_PAGE() { return `/${this.MASTER}${this.RECRUITMENT_LANDING_PAGE}`; },
    DOCUMENT_MASTER: "/document",
    DOCUMENT_MASTER_MANAGE: "/document-manage",
    get DOCUMENT_MASTER_PAGE() { return `/${this.MASTER}${this.RECRUITMENT_LANDING_PAGE}${this.DOCUMENT_MASTER}`; },
    get DOCUMENT_MASTER_MANAGE_PAGE() { return `/${this.MASTER}${this.RECRUITMENT_LANDING_PAGE}${this.DOCUMENT_MASTER_MANAGE}`; },

    RESUME_TEMPLATE_MASTER: "/resume-template",
    get RESUME_TEMPLATE_MASTER_PAGE() { return `/${this.MASTER}${this.RECRUITMENT_LANDING_PAGE}${this.RESUME_TEMPLATE_MASTER}`; },

    ATTENDANCE_LANDING_PAGE: "/attendance",
    get ATTENDANCE_MASTER_LANDING_PAGE() { return `/${this.MASTER}${this.ATTENDANCE_LANDING_PAGE}`; },
    HOLIDAY: "/holiday",
    HOLIDAY_MASTER_MANAGE: "/holiday-manage",
    get HOLIDAY_PAGE() { return `/${this.MASTER}${this.ATTENDANCE_LANDING_PAGE}${this.HOLIDAY}`; },
    get HOLIDAY_MANAGE_PAGE() { return `/${this.MASTER}${this.ATTENDANCE_LANDING_PAGE}${this.HOLIDAY_MASTER_MANAGE}`; },
    POLICY: "/policy",
    DETAILS: "/details",
    get POLICY_PAGE() { return `/${this.MASTER}${this.ATTENDANCE_LANDING_PAGE}${this.POLICY}`; },
    get POLICY_DETAILS_PAGE() { return `/${this.MASTER}${this.ATTENDANCE_LANDING_PAGE}${this.POLICY}${this.DETAILS}`; },
    WEEKOFF_MASTER: "/weekoff-master",
    get WEEKOFF_MASTER_PAGE() { return `/${this.MASTER}${this.ATTENDANCE_LANDING_PAGE}${this.WEEKOFF_MASTER}`; },
    SHIFT: "/shift",
    SHIFT_MANAGE: "/shift-manage",
    get SHIFT_PAGE() { return `/${this.MASTER}${this.ATTENDANCE_LANDING_PAGE}${this.SHIFT}`; },
    get SHIFT_MANAGE_PAGE() { return `/${this.MASTER}${this.ATTENDANCE_LANDING_PAGE}${this.SHIFT_MANAGE}`; },
    ATTENDANCE_CYCLE: "/attendance-cycle",
    get ATTENDANCE_CYCLE_LIST_PAGE() { return `/${this.MASTER}${this.ATTENDANCE_LANDING_PAGE}${this.ATTENDANCE_CYCLE}`; },
    LOCATION: "/locations",
    get LOCATION_LIST_PAGE() { return `/${this.MASTER}${this.ATTENDANCE_LANDING_PAGE}${this.LOCATION}`; },

    COMPENSATION_LANDING_PAGE: "/compensation",
    SALARY:"/salary",
    SALARY_TEMPLATES:"/salary-template",
    get COMPENSATION_SALARY_MASTER_PAGE() { return `/${this.MASTER}${this.COMPENSATION_LANDING_PAGE}${this.SALARY}`},
    get COMPENSATION_SALARY_TEMPLATES_MASTER_PAGE() { return `/${this.MASTER}${this.COMPENSATION_LANDING_PAGE}${this.SALARY_TEMPLATES}` },

    LEAVE_LANDING_PAGE: "/leave",
    get MASTER_LANDING_PAGE() { return `/${this.MASTER}${this.LEAVE_LANDING_PAGE}`; },
    LEAVE_POLICY: "/leave-policy",
    get LEAVE_POLICY_LIST_PAGE() { return `/${this.MASTER}${this.LEAVE_LANDING_PAGE}${this.LEAVE_POLICY}`; }, 

    POLICY_LANDING_PAGE: "/policy",
    get POLICY_MASTER_PAGE() { return `/${this.MASTER}${this.POLICY_LANDING_PAGE}`; },
    COMPANY_POLICY:'/company-policy',
    get COMPANY_POLICY_MASTER_PAGE() { return `/${this.MASTER}${this.POLICY_LANDING_PAGE}${this.COMPANY_POLICY}`; },

    EXIT_POLICY:"/exit",

}



export const NAVIGATE_TICKETS = {
    TICKETS: "/tickets",
    TICKETS_LIST: "/tickets-list",
    TICKET_DASHBOARD: "/ticket-dashboard",
    DETAILS: "/details",
    get TICKETS_DETAILS_PAGE() { return `${this.TICKETS}${this.TICKETS_LIST}${this.DETAILS}`; },
}

export const NAVIGATE_ADMIN_PAGE = {
    ADMIN:'admin',
    SALARY: "/salary",
    CLAIM_MANAGEMENT:'/claim-management',
    REGISTER_REPORTS:'/register-reports',
    ADMIN_REPORTS:'/admin-reports',
    SAMPLE_REPORTS:'/sample-reports',
    LOAN_ADVANCE:'/loan-advance',
    EMPLOEE_SATISFACTION:'/employee-satisfaction',
    EMPLOEE_SATISFACTION_ANALYSIS:'/employee-satisfaction-analysis',
    EMPLOEE_SATISFACTION_ANALYSIS_FULL_URL:'admin/employee-satisfaction-analysis',
    FNF:'/fnf',
    ASSET:'/asset',
    CHECKLIST:'/checklist',

    get SUMMARY_PAGE() { return `${this.ADMIN}${this.SALARY}`},
    get CLAIM_MANAGEMENT_PAGE() { return `${this.ADMIN}${this.CLAIM_MANAGEMENT}`; },
    get REGISTER_REPORTS_PAGE() { return `${this.ADMIN}${this.REGISTER_REPORTS}`; },
    get ADMIN_REPORTS_PAGE() { return `${this.ADMIN}${this.ADMIN_REPORTS}`; },
    get SAMPLE_REPORTS_PAGE() { return `${this.ADMIN}${this.SAMPLE_REPORTS}`; },
    get LOAN_ADVANCE_PAGE() { return `${this.ADMIN}${this.LOAN_ADVANCE}`; },
    get EMPLOEE_SATISFACTION_PAGE() { return `${this.ADMIN}${this.EMPLOEE_SATISFACTION}`; },
    get EMPLOEE_SATISFACTION_ANALYSIS_PAGE() { return `${this.ADMIN}${this.EMPLOEE_SATISFACTION_ANALYSIS}`; },
    get EMPLOEE_FNF_PAGE() { return `${this.ADMIN}${this.FNF}`; },
    get EMPLOEE_ASSET_PAGE() { return `${this.ADMIN}${this.ASSET}`; },
    get CHECKLIST_PAGE() { return `${this.ADMIN}${this.CHECKLIST}`; }
}

export const NAVIGATE_CLAIM_MANAGEMENT = {
    CLAIM_MANAGEMENT: "/claim-management",
    get CLAIM_MANAGEMENT_PAGE() { return `${this.CLAIM_MANAGEMENT}`; },
}

export const NAVIGATE_TAXMANAGEMENT = {
    TAX: "/tax-management",
    TAX_LIST: "/list",
    EMPLOYEETAX :'/employee-tax',
    TAXDASHBOARD: "/manage-tax",
    DETAILS: "/details",
    TAX_COMPANY_LIST: "/company-tax-cycle",
    PREVIOUS_EMP_FORM: "/previous-employee"
    // get TICKETS_DETAILS_PAGE() { return `${this.TICKETS}${this.DETAILS}`; },
}

export const NAVIGATE_ANNOUNCEMENT = {
    ANNOUNCEMENT: "/announcement",

}

export const NAVIGATE_IT = { 
    IT: "/it",
    ASSETS: "/assets",

    get IT_ASSETS_LISTING_PAGE() { return `${NAVIGATE_IT.IT}${this.ASSETS}`; },
}

export const NAVIGATE_ACTION_VIA_EMAIL = {
    ACTION_VIA_EMAIL: "/action-via-email"
}

export const NAVIGATE_DOWNLOAD_CENTER = {
    DOWNLOAD_CENTER:"/download-center",
}